import styled from 'styled-components';
import { InteriorSelectStyled } from '../InteriorSelectStyled';
import { rem } from 'polished';

export const InteriorSelectStyledAP = styled(InteriorSelectStyled)`
    .isSelected {
        background: ${({ theme }) => theme.colors.primaryLight};
    }
`;
